import * as React from 'react';
import featherIcons from 'feather-icons/dist/feather-sprite.svg';
import { FeatherIconName } from './FeatherIconName';

interface Props
  extends Pick<React.ComponentProps<'svg'>, 'className' | 'style'> {
  icon: FeatherIconName;
}

export const FeatherIcon: React.FC<Props> = ({ icon, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <use href={`${featherIcons}#${icon}`} />
    </svg>
  );
};
